import { render, staticRenderFns } from "./BrochureCard.vue?vue&type=template&id=03a9890f&scoped=true&"
import script from "./BrochureCard.vue?vue&type=script&lang=js&"
export * from "./BrochureCard.vue?vue&type=script&lang=js&"
import style0 from "./BrochureCard.vue?vue&type=style&index=0&id=03a9890f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a9890f",
  null
  
)

export default component.exports